import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ScannedActionsSubject } from '@ngrx/store';
import { LoginComponent, AuthService, LoginCheckService } from 'gung-standard';
import { first } from 'rxjs';

@Component({
  selector: 'otto-olsen-login',
  templateUrl: './otto-olsen-login.component.html',
  styleUrls: ['./otto-olsen-login.component.scss'],
  standalone: false
})
export class OttoOlsenLoginComponent extends LoginComponent implements OnInit {
  protected defaultTab: string = '';

  ngOnInit(): void {
    super.ngOnInit();

    this.route.queryParams.pipe(first()).subscribe(queryParams => {
      this.defaultTab = queryParams['tab'] || 'login';
    });
  }

  onSubmit() {
    super.onSubmit();
    localStorage.removeItem('InterfaceMode');
  }
}
